import { coveredTop } from './coveredTop';

/**
 * Focus back on the control that opened something (Help, Feedback), without moving the page
 * (QA-032, QA-060). WP-FOCUS-IN-VIEW: when that control is outside the window (in a short window,
 * Help's heading can take the page up, away from the footer), or under the Level 2 bar, it's
 * brought into view, the least distance there is. Measured a frame later, once whatever closed has
 * left the page.
 */
export function returnFocus(target: HTMLElement): void {
  target.focus({ preventScroll: true });
  window.requestAnimationFrame(() => {
    if (document.activeElement !== target) return;
    // Less than a pixel over the edge (layout is in fractions, scrolling in whole pixels) is in view.
    const { top, bottom } = target.getBoundingClientRect();
    const outside = top < coveredTop() - 1 || bottom > window.innerHeight + 1;
    if (outside && typeof target.scrollIntoView === 'function')
      target.scrollIntoView({ block: 'nearest' });
  });
}
